// extracted by mini-css-extract-plugin
module.exports = {"warning":"Message-module--warning--3IRtx","text":"Message-module--text--3H5b_"};